<template>
  <LoaderFullScreen v-if="loading" :preserve-navigation="showNavigationShell" />
  <component :is="layout">
    <router-view v-model:layout.sync="layout" :key="keyRV" />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { useStore } from '@/store';
import { MenuActionTypes } from './store/menu/action-types';
import { AuthActionTypes } from './store/auth/action-types';

import { LoaderActionTypes } from './store/loader/action-types';
import { useOidcStore } from 'vue3-oidc';
const { state } = useOidcStore();

export default defineComponent({
  name: 'App',
  async mounted() {
    try {
      await useStore().dispatch(LoaderActionTypes.ACTION_SHOW);
      const user = await state.value.userManager?.getUser();

      if (user) {
        await useStore().dispatch(AuthActionTypes.ACTION_LOGIN);
      }
    } finally {
      await useStore().dispatch(LoaderActionTypes.ACTION_HIDE);
    }
  },
  watch: {
    ObraSelecionada(novaObra: any, obraAnterior: any) {
      if (this.$route.name == 'proxyLegado') return;

      const getSignature = (obra: any) => {
        const id = obra?.gesObraId ?? '';
        const descricao = obra?.descricao ?? '';
        return `${id}|${descricao}`;
      };

      if (getSignature(novaObra) !== getSignature(obraAnterior)) {
        this.keyRV += 1;
      }
    }
    // contratoSelecionado() {
    //   if (this.$route.name != 'proxyLegado') {
    //     this.keyRV += 1;

    //   }
    // },
  },
  data() {
    return {
      keyRV: 0 as number,
      layout: 'div'
    };
  },
  computed: {
    ...mapGetters({
      ObraSelecionada: 'getObraSelecionada',
      contratoSelecionado: 'getCodigoContrato'
    }),
    loading() {
      return useStore().state.loader.loading || useStore().state.loader.navigationLoading;
    },
    showNavigationShell() {
      return !useStore().getters.getIsLegacy && this.$route.matched.some((route) => route.name === 'home');
    }
  },
  methods: {
    ...mapActions([MenuActionTypes.ACTION_SET_OBRA])
  }
});
</script>

<style lang="scss">
@import '@/assets/scss/app-modern.scss';
@import '@/assets/scss/icons.scss';

html[data-theme='dark'] {
  .swal2-toast {
    background-color: var(--ct-bg-topbar);
    color: white;
  }

  .swal2-timer-progress-bar {
    background-color: white;
  }
}

html[data-theme='light'] {
  .swal2-toast {
    background-color: var(--ct-bg-topbar);
    color: black;
  }

  .swal2-title {
    color: rgb(52, 52, 52);
  }

  .swal2-timer-progress-bar {
    background-color: rgb(52, 52, 52);
  }
}

span[role='alert'] {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.card form label + .form-control {
  margin-bottom: unset !important;
}

.swal2-actions .btn {
  margin: 0px 8px 0px 8px;
}

.multiselect.is-active {
  box-shadow: none !important;
}

/* .wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;

} */

/*************** road and wrapper for car and road ******************/
.car-road {
  position: relative !important;
  width: 50%;
  margin: 0 auto !important;
}

.multiselect-dropdown {
  height: 300px !important;
}

.road {
  height: 230px;
  width: 100%;

  margin: 0 auto;
}

.white-stripe-top {
  height: 8px;
  width: 100%;
  background-color: white;
  position: absolute;
  top: 8px;
  z-index: 100;
}

.yellow-stripe {
  height: 8px;
  width: 100%;
  position: absolute;
  top: 50%;
  background-image: linear-gradient(90deg, yellow 43%, transparent 0%, black 50%, transparent);
  background-size: 300px;
}

.white-stripe-bottom {
  height: 20px;
  width: 100%;
  background-color: white;
  position: absolute;
  bottom: 8px;
}

/************************** car ************************************/
.car-wrapper {
  width: 100%;

  -webkit-animation: go 2s infinite;
  -moz-animation: go 2s infinite;
  -o-animation: go 2s infinite;
  animation: go 2s infinite;
  z-index: 100;
  top: 0px !important;
}

@-webkit-keyframes go {
  0% {
    transform: translate(-50px);
  }

  30% {
    transform: translate(30px);
  }

  50% {
    transform: translate(30px);
  }

  100% {
    transform: translate(520px);
  }
}

@-moz-keyframes go {
  0% {
    transform: translate(-50px);
  }

  30% {
    transform: translate(30px);
  }

  50% {
    transform: translate(30px);
  }

  100% {
    transform: translate(520px);
  }
}

@-o-keyframes go {
  0% {
    transform: translate(-50px);
  }

  30% {
    transform: translate(30px);
  }

  50% {
    transform: translate(30px);
  }

  100% {
    transform: translate(520px);
  }
}

@keyframes go {
  0% {
    transform: translate(-50px);
  }

  30% {
    transform: translate(30px);
  }

  50% {
    transform: translate(30px);
  }

  100% {
    transform: translate(520px);
  }
}

@-webkit-keyframes roter {
  0% {
    transform: rotate(0deg);
  }

  47% {
    transform: rotate(1080deg);
  }

  70% {
    transform: rotate(1080deg);
  }

  100% {
    transform: rotate(2160deg);
  }
}

@-moz-keyframes roter {
  0% {
    transform: rotate(0deg);
  }

  47% {
    transform: rotate(1080deg);
  }

  70% {
    transform: rotate(1080deg);
  }

  100% {
    transform: rotate(2160deg);
  }
}

@-o-keyframes roter {
  0% {
    transform: rotate(0deg);
  }

  47% {
    transform: rotate(1080deg);
  }

  70% {
    transform: rotate(1080deg);
  }

  100% {
    transform: rotate(2160deg);
  }
}

@keyframes roter {
  0% {
    transform: rotate(0deg);
  }

  47% {
    transform: rotate(1080deg);
  }

  70% {
    transform: rotate(1080deg);
  }

  100% {
    transform: rotate(2160deg);
  }
}

/*********** ConsulteGrid ******************/
.page-link {
  cursor: pointer;
}
</style>
